import { CustomerChat } from '../../../models/limits/chatLimits.model';
import { useGet, useSend } from '../../useApi';

// GET /admin/users/{id}/chat-limit, POST it (own allowance), DELETE …/{limit_id},
// POST …/reset. Every write answers with the refreshed view.
const useCustomerChatLimit = () => {
  const { data, loading, fetch, setData } = useGet<CustomerChat>('Failed to load the chat allowance');
  const { loading: saving, send } = useSend<CustomerChat>('Could not change the chat allowance');
  const base = (userId: string) => `api/v1/admin/users/${userId}/chat-limit`;
  const write = (config: Parameters<typeof send>[0], onDone?: () => void) =>
    send(config, (body) => {
      setData(body);
      onDone?.();
    });
  return {
    chat: data,
    loading,
    saving,
    fetchChat: (userId: string) => fetch(base(userId)),
    setLimit: (userId: string, body: { daily_units: number; reason: string; expires_at: string | null }, onDone?: () => void) =>
      write({ url: base(userId), method: 'post', data: body }, onDone),
    removeLimit: (userId: string, limitId: string, reason: string, onDone?: () => void) =>
      write({ url: `${base(userId)}/${limitId}`, method: 'delete', data: { reason } }, onDone),
    resetToday: (userId: string, reason: string, onDone?: () => void) =>
      write({ url: `${base(userId)}/reset`, method: 'post', data: { reason } }, onDone),
  };
};

export default useCustomerChatLimit;
